module.exports = __webpack_public_path__ + "img/考试宝典-每日一练.52bed582.jpeg";